var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 16",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    rx: 1.61,
    ry: 1.61,
    fill: "#d5d9dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.42 9.62v3.5h-2.05V3.17h3.89a4.56 4.56 0 012 .41 3 3 0 011.31 1.17A3.28 3.28 0 0119 6.47a2.85 2.85 0 01-1 2.3 4.12 4.12 0 01-2.77.85zm0-1.66h1.84a1.79 1.79 0 001.24-.39 1.38 1.38 0 00.42-1.09 1.62 1.62 0 00-.43-1.18 1.6 1.6 0 00-1.19-.47h-1.88z"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/media/P.svg";
export { SvgP as ReactComponent };